import React, { Dispatch, SetStateAction } from 'react';
import './service-request.css';
import { useIntl } from 'react-intl';
import ToolTipAnchor from '../../common/tooltip';
import { isNuEar } from '../../../hooks/nuear-hook';
import { ISession } from '../../../models/pro-sites';
import { IServiceRequestInitial } from '../../../models/service-request';

interface IServiceRequestShippingProps {
    session: ISession | null;
    setServiceRequest: Dispatch<SetStateAction<IServiceRequestInitial>>;
    shippingLabel: boolean;
}
const ServiceRequestShipping = ({
    session,
    setServiceRequest,
    shippingLabel,
}: IServiceRequestShippingProps) => {
    const intl = useIntl();
    const shippingToolTipMessage = `    
        <h3 class="shipping-popover-title">UPS Printable Labels</h3>
        <div class="shipping-popover-content">
            <div>
                <p><strong>Purpose: </strong>
                <span>Replaces billable stamps.</span></p>
            </div>
            <div>
                <p><strong>Benefits: </strong>
                <span>Easy to use and always accessible.</span></p>
            </div>
            <div>
                <span>Your inbound shipment is visible when it is picked up. Inbound shipments
                using this form will still be billed to Starkey.</span>
            </div>
        </div>`;

    return (
        <>
            <div className="well gutter-top">
                <h3
                    className={
                        isNuEar(session!.siteNumber) ? 'nuEar' : 'starkey'
                    }
                    style={{ color: '#58595b' }}
                >
                    <span style={{ marginBottom: '-5px' }}>
                        {intl.formatMessage({
                            id: 'UPS_Shipping_Label',
                            defaultMessage: 'UPS Shipping Label',
                        })}
                    </span>
                    <ToolTipAnchor
                        toolTipMessage={shippingToolTipMessage}
                        variant="light"
                    />
                </h3>
                <div className="row">
                    <div className="checkbox col-xs-12">
                        <img
                            className="hidden-xs shipping-img"
                            src="/images/icons/fedex.png"
                            alt=""
                        />
                        <label>
                            <input
                                className="checkbox"
                                name="printAdditionalUPS"
                                type="checkbox"
                                checked={shippingLabel}
                                onChange={() =>
                                    setServiceRequest((serviceRequest) => ({
                                        ...serviceRequest,
                                        shippingLabel:
                                            !serviceRequest.shippingLabel,
                                    }))
                                }
                            />
                            <span style={{ color: '#58595b' }}>
                                {intl.formatMessage({
                                    id: 'Print_Additional _UPS',
                                    defaultMessage:
                                        'Print Additional UPS Shipping Label',
                                })}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServiceRequestShipping;
